module.exports = __webpack_public_path__ + "img/entia-portafolio-energia-carrusel-2.5ec1c51f.webp";